import React from "react";
import {
  makeStyles,
  createStyles,
  Button,
  Theme,
  Tooltip,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import clsx from "clsx";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // backgroundColor: "lightgreen",
      width: "100%",
      display: "inline-flex",
    },
    groups: {
      // backgroundColor: "powderblue",
      display: "inline-flex",
      overflowX: "auto",
      overflowY: "hidden",
      "&::-webkit-border-radius": 3,
      borderRadius: 3,
      // スクロールバー:全体
      "&::-webkit-scrollbar": {
        width: 8,
        backgroundColor: "#eee",
      },
      // スクロールバー:水平
      "&::-webkit-scrollbar:horizontal": {
        height: 8,
      },
      // スクロールバー:左右末端のボタン
      "&::-webkit-scrollbar-button": {
        width: 8,
        height: 8,
        backgroundColor: "#ccc",
      },
      // スクロールバー:ツマミ部分
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#bbb",
      },
    },
    groupsShowControl: {
      maxWidth: "84%",
    },
    control: {
      display: "inline-flex",
      justifyContent: "start",
      alignItems: "center",
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      marginLeft: theme.spacing(1.0),
    },
    controlButtons: {
      width: "12rem",
    },
    clearButton: {},
    applyButton: {
      marginLeft: theme.spacing(0.5),
    },
    controlDoing: {
      width: "16rem",
    },
    controlDone: {
      width: "16rem",
    },
    controlText: {
      marginLeft: theme.spacing(1),
      fontSize: "0.7rem",
      color: theme.palette.text.disabled,
    },
  })
);

interface Props {
  mode: "normal" | "invisible" | "disabled" | "doing" | "done";
  onClear?: () => void;
  onApply?: () => void;
  children: React.ReactNode;
}

/** 同義語編集可能コンポーネント */
export function SynonymEditableComponent(props: Props) {
  const classes = useStyles();
  const { mode, onClear, onApply, children } = props;

  // グループのクラスを動的に設定する
  const classNameGroups = ["normal", "disabled", "doing", "done"].includes(mode)
    ? clsx(classes.groups, classes.groupsShowControl)
    : clsx(classes.groups);

  // コントロール要素の取得
  let controlComponent = <></>;
  // if (["normal", "invisible", "disabled"].includes(mode)) {
  if (["invisible", "normal", "disabled"].includes(mode)) {
    controlComponent = (
      <div
        className={clsx(classes.control, classes.controlButtons)}
        style={{
          display: ["normal", "disabled"].includes(mode)
            ? "inline-flex"
            : "none",
        }}
      >
        <Tooltip title="同義語の変更をクリアする">
          <span>
            {/*
            ボタンが非活性になるとTooltipが表示できなくなるためspanで囲む必要がある
            Tooltip --- Disabled Elements
            https://material-ui.com/components/tooltips/#disabled-elements
        */}
            <Button
              className={classes.clearButton}
              variant="contained"
              onClick={onClear}
              size="small"
              disabled={mode === "disabled"}
            >
              クリア
            </Button>
          </span>
        </Tooltip>
        <Tooltip title="同義語の変更を適用する">
          <span>
            {/*
            ボタンが非活性になるとTooltipが表示できなくなるためspanで囲む必要がある
            Tooltip --- Disabled Elements
            https://material-ui.com/components/tooltips/#disabled-elements
        */}
            <Button
              className={classes.applyButton}
              variant="contained"
              onClick={onApply}
              size="small"
              color="primary"
              disabled={mode === "disabled"}
            >
              適用
            </Button>
          </span>
        </Tooltip>
      </div>
    );
  } else if (mode === "doing") {
    // 更新待ち
    controlComponent = (
      <div className={clsx(classes.control, classes.controlDoing)}>
        <div>
          <CircularProgress size={20} />
        </div>
        <Typography component="span" className={classes.controlText}>
          更新中…
        </Typography>
      </div>
    );
  } else if (mode === "done") {
    // 更新完了
    controlComponent = (
      <div className={clsx(classes.control, classes.controlDone)}>
        <Typography component="span" className={classes.controlText}>
          更新しました。再検索して下さい。
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classNameGroups}>{children}</div>
      {controlComponent}
    </div>
  );
}
